import Button from 'components/Button';
import { FC } from 'react';
import { Link, Route, Routes } from 'react-router-dom';

const SettingsButtonRoutes: FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Link to={`/settings/edit-information`}>
            <Button variant="outlined">Modifier les informations</Button>
          </Link>
        }
      />
    </Routes>
  );
};

export default SettingsButtonRoutes;
